import { boundApiFetch } from "../core/boundApiFetch";

// =====================
// DIRECT MESSAGES (DM)
// =====================

/**
 * Restituisce il conteggio dei messaggi DM non letti.
 */
export async function getDmUnreadCount() {
  return boundApiFetch<{ unread: number }>("/api/dm/unread-count");
}

/**
 * Recupera la lista dei thread DM dell'utente.
 * @param limit - Numero massimo di thread da restituire (default 30)
 */
export async function getDmThreads(limit: number = 30) {
  const qs = new URLSearchParams({ limit: String(limit) });
  return boundApiFetch<{ threads: any[] }>(`/api/dm/threads?${qs.toString()}`);
}

/**
 * Recupera i messaggi di un thread DM specifico.
 * @param threadId - ID del thread
 * @param limit - Numero massimo di messaggi da restituire (default 200)
 */
export async function getDmMessages(threadId: string, limit: number = 200) {
  const qs = new URLSearchParams({ limit: String(limit) });
  return boundApiFetch<{ messages: any[] }>(
    `/api/dm/threads/${threadId}/messages?${qs.toString()}`
  );
}

/**
 * Invia un messaggio in un thread DM esistente.
 * @param threadId - ID del thread
 * @param body - Testo del messaggio
 */
export async function sendDmMessage(threadId: string, body: string) {
  return boundApiFetch<{ message: any }>(
    `/api/dm/threads/${threadId}/messages`,
    {
      method: "POST",
      body: JSON.stringify({ body }),
    }
  );
}

/**
 * Avvia una nuova conversazione DM con un altro utente.
 * @param to_user_id - ID dell'utente destinatario
 * @param message - Messaggio iniziale opzionale
 */
export async function dmInvite(to_user_id: string, message?: string) {
  return boundApiFetch<{ thread_id: string; message: any }>(
    "/api/dm/invite",
    {
      method: "POST",
      body: JSON.stringify({ to_user_id, message }),
    }
  );
}

/**
 * Elimina / nasconde una conversazione per l'utente corrente.
 * Se entrambi i partecipanti la nascondono, il thread viene rimosso.
 */
export async function deleteDmThread(threadId: string) {
  return boundApiFetch<{ ok: boolean }>(
    `/api/dm/threads/${threadId}`,
    { method: "DELETE" }
  );
}

/**
 * FEAT DM-CHAT-24H (Set 2026): eliminazione DEFINITIVA per TUTTI i
 * partecipanti — riservata a chi ha iniziato la conversazione
 * (created_by) o a un admin. Cancella messaggi + thread.
 */
export async function purgeDmThread(threadId: string) {
  return boundApiFetch<{ ok: boolean; purged: boolean }>(
    `/api/dm/threads/${threadId}/purge`,
    { method: "DELETE" }
  );
}
